import { Form, Col } from "antd";
import { getInputEl } from "./getInputEl";
import { TableTD } from "./table-td";

// 自定义表单渲染
export const FormItem = (props) => {
    const { formConfig, item, activeKey, children, onClick } = props;

    // 上传事件转换为表单字段 处理多文件以及上传错误
    const onUploadChange = (e) => {
        // 多文件
        if (e instanceof Array) {
            console.log(111, e);
            return e.filter((item) => item.status !== "error");
        }
        // 单文件
        return e && e.fileList.filter((item) => item.status !== "error");
    };

    return (
        <Col
            span={item.span || formConfig.span}
            className={`col-item ${item.key === activeKey ? "active" : ""} item_${item.key}`}
            onClick={() => onClick(item)}
        >
            <Form.Item
                {...item.formItemProps}
                {...(formConfig.labelAlign
                    ? { labelAlign: formConfig.labelAlign }
                    : {})}
                {...(!item.showLabel ? { label: "" } : {})}
                {...(!item.showLabel || formConfig.layout !== "horizontal"
                    ? {
                        labelCol: undefined,
                        wrapperCol: undefined,
                    }
                    : {})}
                {...(item.type === "upload"
                    ? {
                        getValueFromEvent: onUploadChange,
                    }
                    : {})}
            >
                {
                    item.type === 'table' ? (
                        <TableTD {...props} />
                    ) : getInputEl(item)
                }
            </Form.Item>
            {children}
        </Col>
    );
};
